import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import BaseTab from './BaseTab';

interface FrontendFeaturesTabProps {
  isDark: boolean;
  colors: any;
  discordFont: any;
  glassStyle: any;
  lokiGradient: string;
  goldColor: string;
  isMobile: boolean;
}

const FrontendFeaturesTab: React.FC<FrontendFeaturesTabProps> = (props) => {
  return (
    <BaseTab
      {...props}
      title="Frontend Key Features"
      emoji="🌟"
    >
      <Typography variant="h6" sx={{ color: props.goldColor, mb: 2 }}>
        Comprehensive Feature Set
      </Typography>
      <Grid container spacing={3}>
        {[
          {
            icon: '☕',
            title: 'Café Discovery & Exploration',
            features: [
              'Advanced search by location & amenities',
              'Real-time WiFi speed & occupancy data',
              'Google Maps integration',
              'Community-contributed photos & reviews',
              'Personal visit history tracking',
            ],
            color: '#0F3B2E',
          },
          {
            icon: '👨‍💻',
            title: 'Live Presence & Networking',
            features: [
              'Real-time location sharing',
              'Online/offline status indicators',
              'Proximity-based matching',
              'Interest-based collaborator discovery',
            ],
            color: '#1D5C4A',
          },
          {
            icon: '🧑‍🤝‍🧑',
            title: 'Community Building',
            features: [
              'City-based communities',
              'Interest-based groups',
              'Moderation system',
              'Role-based permissions',
              'Threaded discussion forums',
            ],
            color: props.goldColor,
          },
          {
            icon: '💬',
            title: 'Real-time Chat System',
            features: [
              'Direct messaging',
              'Community group chats',
              'Rich media support (images, GIFs)',
              '@mentions & notifications',
              'Typing indicators',
            ],
            color: '#051814',
          },
          {
            icon: '👤',
            title: 'User Profiles & Social',
            features: [
              'Comprehensive bio & portfolio',
              'Social media integration',
              'Custom banners & avatars',
              'Shareable profile pages',
            ],
            color: '#0F3B2E',
          },
          {
            icon: '👑',
            title: 'Admin Dashboard',
            features: [
              'User management',
              'Content moderation',
              'Analytics dashboard',
              'System monitoring',
              'Feedback management',
            ],
            color: '#1D5C4A',
          },
        ].map((feature, index) => (
          <Grid size={{ xs: 12, md: 6 }} key={index}>
            <Card sx={{ height: '100%', borderLeft: `4px solid ${feature.color}` }}>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Typography variant="h4" sx={{ mr: 2 }}>
                    {feature.icon}
                  </Typography>
                  <Typography variant="h6" fontWeight={700}>
                    {feature.title}
                  </Typography>
                </Box>
                <List dense>
                  {feature.features.map((item, idx) => (
                    <ListItem key={idx} sx={{ py: 0.5 }}>
                      <ListItemIcon sx={{ minWidth: 32 }}>
                        <CheckCircle sx={{ color: feature.color, fontSize: 16 }} />
                      </ListItemIcon>
                      <ListItemText
                        primary={item}
                        primaryTypographyProps={{ variant: 'body2' }}
                      />
                    </ListItem>
                  ))}
                </List>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </BaseTab>
  );
};

export default FrontendFeaturesTab;